import { render, staticRenderFns } from "./HomeCyAiTab.vue?vue&type=template&id=423b028c&scoped=true"
import script from "./HomeCyAiTab.vue?vue&type=script&lang=js"
export * from "./HomeCyAiTab.vue?vue&type=script&lang=js"
import style0 from "./HomeCyAiTab.vue?vue&type=style&index=0&id=423b028c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b028c",
  null
  
)

export default component.exports